import { Button, ButtonGroup, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import DialogDescripcion from "../../ProveedoresTerrestres/FExtraPaqueteTerrestre/DialogDescipcion";
import DeleteIcon from '@material-ui/icons/Delete';
import AltaExtraVuelo from "./AltaExtraVuelo";
import { formatDinero } from "../../../utils/formatDinero";
import DialogTipoExtra from "../../ProveedoresTerrestres/FExtraPaqueteTerrestre/DialogTipoExtra";
import { useMemo } from "react";
import ActualizaExtraVuelo from "./ActualizaExtraVuelo";
import { DialogMessage } from "../../../global/DialogMessage";
import { 
    eliminarExtraVueloAction, 
    eliminarExtraVueloRegresoAction, 
    obtenerExtrasVueloAction, 
    obtenerExtrasVueloRegresoAction 
} from "../../../ducks/proveedorAereolineaDuck";
import { ToastMessage } from "../../../global/ToastMessage";
import Swal from "sweetalert2";
import FTipoExtraVuelo from "./FTipoExtraVuelo";

const useStyles = makeStyles({
  root: {
    width: '100%'
  },
  container: {
    display: "block",
    maxHeight: 350,
  },
})

const TablaExtraVuelo = ({ tipo }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { vueloExtras, vueloExtrasRegreso, vueloTarget } = useSelector(store => store.vueloProveedor);
    const esIda = tipo === "ida";
    const rows = useMemo(() => {
        const extras = esIda 
            ? vueloExtras ?? [] 
            : vueloExtrasRegreso ?? []
        return extras
        
    },[esIda, vueloExtras, vueloExtrasRegreso]);

    const onDelete = (row) => {
        DialogMessage.fire({
          title: '¿Estas seguro?',
          text: "¡No podrás revertir esto!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: '¡Eliminarlo!',
          cancelButtonText: '¡Cancelar!',
          reverseButtons: true
        }).then((result) => {

            const extra = {
                idVueloProveedorExtra: row?.IdVueloProveedorExtra,
            }

            const extraRegreso = {
                idVueloRedondoExtra: row?.IdVueloRedondoExtra,
            };

            const dispatchAction = tipo === "regreso" 
                ? eliminarExtraVueloRegresoAction
                : eliminarExtraVueloAction
            
            const extraData = tipo === "regreso" ? extraRegreso : extra;

            if (result.isConfirmed) {
                dispatch(dispatchAction(extraData)).then(Response => {

                    if (tipo === "regreso") {
                        dispatch(obtenerExtrasVueloRegresoAction({ vuelo: vueloTarget?.VueloRedondo.IdVueloRedondo }));
                    } else {
                        dispatch(obtenerExtrasVueloAction({ vuelo: vueloTarget?.IdVueloProveedor }));
                    }

                    ToastMessage.fire(
                        '¡Elimminado!',
                        '¡El extra ha sido eliminada!',
                        'success'
                    )
                })
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                ToastMessage.fire(
                    'Cancelado',
                    'No se ha realizado ningun cambio',
                    'info'
                )
            }
        })
    }

    return(
        <div style={{width: "100%"}}>
            <div style={{display: "flex", justifyContent: "end", marginBottom: "1rem"}}>
                <AltaExtraVuelo tipo={tipo} />
            </div>
        
            <TableContainer component={Paper} className={classes.container} style={{display: "block"}}>
                <Table size="small" stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow key="data-table-header">
                            <TableCell align="center" key="extra">Nombre</TableCell>
                            <TableCell align="center" key="origen">Origen</TableCell>
                            <TableCell align="center" key="suplemento">Suplemento</TableCell>
                            <TableCell align="center" key="tipo">Tipo</TableCell>
                            <TableCell align="center" key="descripcion">Descripción</TableCell>
                            <TableCell align="center" key="acciones"></TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {rows.length > 0 ? rows.map((row, index) => {
                            return (
                                <TableRow key={row.IdExtra}>
                                    <TableCell align="center">{row?.Extra?.Nombre}</TableCell>
                                    <TableCell align="center">{row.Extra?.Origen?.Nombre}</TableCell>
                                    <TableCell align="center">{formatDinero(row.Suplemento)}</TableCell>
                                    <TableCell align="center">
                                        {(row.CatExtra?.idCatExtra > 0) 
                                            ? <div>{row.CatExtra?.Descripcion} <DialogTipoExtra TipoExtra={row.CatExtra?.Descripcion} idExtra={row.Extra?.IdExtra} /></div>
                                            : <span>Sin Asignar</span>
                                        }
                                    </TableCell>
                                    <TableCell align="center">
                                        <DialogDescripcion Descripcion={row.Extra?.Descripcion} />
                                    </TableCell>
                                    <TableCell align="center">
                                        <ButtonGroup
                                            color="primary"
                                            size="small"
                                            aria-label="small outlined  button group"
                                        >
                                            <FTipoExtraVuelo
                                                tipo={tipo}
                                                idExtra={row.Extra?.IdExtra}
                                                Nombre={row.Extra?.Nombre}
                                                esRedondo={row?.EsRedondo}
                                                idVueloProveedorExtra={row?.IdVueloProveedorExtra}
                                            />
                                            <ActualizaExtraVuelo
                                                tipo={tipo}
                                                esRedondo={row?.EsRedondo}
                                                idExtra={row?.Extra?.IdExtra}
                                                Nombre={row?.Extra?.Nombre}
                                                Precio={row?.Suplemento}
                                                Descripcion={row.Extra?.Descripcion}
                                                Moneda={row?.Moneda ? `${row?.Moneda.Clave}` : ""}
                                                idVueloProveedorExtra={row?.IdVueloProveedorExtra}
                                                idVueloRedondoExtra= {row?.IdVueloRedondoExtra}
                                            />
                                            <Button onClick={() => onDelete(row)}>
                                                <DeleteIcon />
                                            </Button>
                                        </ButtonGroup>
                                    </TableCell>
                                </TableRow>
                            )
                        }) : 
                            <div style={{padding: "1rem"}}>
                               No hay extras registrados
                            </div>
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}

export default TablaExtraVuelo;